export default __webpack_public_path__ + "static/media/ArpitaProfileAvatar1.e0de4ea0.png";